import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import CampSessionGroupCreateEditForm from './Components/CampSessionGroupCreateEditForm';
import CampSessionGroupApi from './CampSessionGroupApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: CampSessionGroupCreateEditForm,
                getCreate: CampSessionGroupApi.create,
                defaults: {},
                successMessage: "Camp Session Group Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}